import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  // Mirage needs to behave like the real API. There is no `skinny-locations`
  // concept there, so we need to overwrite the relation here.
  employee: belongsTo('employee'),
  location: belongsTo('location'),
});
